import { render, staticRenderFns } from "./PastExam.vue?vue&type=template&id=41dce498&scoped=true&"
import script from "./PastExam.vue?vue&type=script&lang=js&"
export * from "./PastExam.vue?vue&type=script&lang=js&"
import style0 from "./PastExam.vue?vue&type=style&index=0&id=41dce498&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41dce498",
  null
  
)

export default component.exports